export const formatOrderRestriction = (timeStr) => {
  if (!timeStr) return "none";
  if (timeStr === "00:00") return "none";

  const [hours, minutes] = timeStr.split(":").map(Number);
  const totalMinutes = hours * 60 + minutes;

  return `${totalMinutes} minute${totalMinutes !== 1 ? "s" : ""}`;
};
